<template>
  <ul class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
    <li v-for="feature in features" :key="feature.slug">
      <router-link
        :to="url(feature.slug)"
        class="flex space-x-2 px-2 py-1 items-center border border-gray-300 dark:border-gray-500 shadow-sm hover:bg-cyan-50 dark:hover:bg-cyan-800 transition"
      >
        <FeatureIcon :feature="feature" class="w-8" />
        <div class="font-semibold">{{ feature.name }}</div>
      </router-link>
    </li>
  </ul>
</template>

<script setup lang="ts">
  import FeatureIcon from '&/FeatureIcon.vue'

  const props = defineProps<{
    features: object[]
    resultSaveFolder?: string
  }>()

  function url(slug) {
    if (props.resultSaveFolder) {
      return `/${slug}?task=${props.resultSaveFolder}`
    } else {
      return `/${slug}`
    }
  }
</script>
